import React from 'react';
import { MainContentProps } from './types/LayoutTypes';
import { ContentContainer, StyledPaper } from './styles/LayoutStyles';
import { Header } from './Header';

export const MainContent: React.FC<MainContentProps> = ({ children }) => {
  return (
    <ContentContainer>
      <Header />
      <StyledPaper>
        {children}
      </StyledPaper>
    </ContentContainer>
  );
}; 